// extracted by mini-css-extract-plugin
export default {"flexRow":"ProductListForPromotion_flexRow__RkRFF","more":"ProductListForPromotion_more__VBA+X"};